/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import { default as PasswordForm } from './password-change';
import { submitNewPassword, handleContext } from '../../actions/login.action';
import history from '../../history';
import { buildDispatchable } from '../../actions/_action-utilities';
const mapStateToProps = function(state) {
    return {
        ...state.login
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        handleNewPassword: async (choice)=>{
            runDispatchable(()=>{
                return dispatch(submitNewPassword(choice));
            });
        },
        handleContinue: ()=>{
            runDispatchable(()=>{
                return dispatch(handleContext());
            });
        },
        handleNavigateHome: ()=>{
            runDispatchable(()=>{
                history.push('/');
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PasswordForm);
